import { call, put, race, take, takeEvery, fork } from "redux-saga/effects";
import { eventChannel } from "redux-saga";

import {
  showErrorMessage,
  showSuccessMessage
} from "../../../redux-saga/redux/toast";
import BetslipService from "../../services/betslip";
import {
  ClearAllBat,
  addBet,
  placebetFailure,
  placebetStart,
  placebetSuccess,
  removeBet,
  updateBetsWithLatestApiData,
  updateBetsWithSocketData
} from "../../redux/betslip";
import {
  compareInString,
  decodeSocketData,
  isBetEqualToOutcome
} from "../../../container/SportsBookNode/utils/common/functions";
import {
  liveSocket,
  preLiveSocket,
  betslipPreMatchEvent,
  betslipLiveMatchEvent
} from "../../../container/SportsBookNode/utils/common/socket.config";

function* betSlipWatcher() {
  yield takeEvery(placebetStart.type, placeBetWorker);
  yield takeEvery(addBet.type, addSocketToBets);
}

function subscribe(bet) {
  return eventChannel((emitter) => {
    const handler = async (data) => {
      try {
        const data_1 = await decodeSocketData(data);
        return emitter(updateBetsWithSocketData({ ...data_1?.data }));
      } catch (err) {
        console.log(err);
      }
    };

    const matchRoomId = `${bet.sportId}${bet.tournamentId}${bet.matchId}`;
    const eventName = bet.isLive
      ? `${betslipLiveMatchEvent}/${matchRoomId}`
      : `${betslipPreMatchEvent}/${matchRoomId}`;
    let socket = bet.isLive ? liveSocket : preLiveSocket;
    socket.emit("joinroom", [eventName]);
    socket.on(`${eventName}`, handler);

    return () => {
      const matchRoomId = `${bet.sportId}${bet.tournamentId}${bet.matchId}`;
      const eventName = bet.isLive
        ? `${betslipLiveMatchEvent}/${matchRoomId}`
        : `${betslipPreMatchEvent}/${matchRoomId}`;
      let socket = bet.isLive ? liveSocket : preLiveSocket;
      socket.emit("leaveroom", [eventName]);
      socket.off(`${eventName}`, handler);
    };
  });
}

function* readBets(payload) {
  try {
    const betsChannel = yield call(subscribe, payload);
    while (true) {
      let { socketAction, removebet, clearAllBet } = yield race({
        socketAction: take(betsChannel),
        removebet: take(removeBet.type),
        clearAllBet: take(ClearAllBat.type)
      });
      if (socketAction) {
        yield put(socketAction);
      } else {
        if (clearAllBet) {
          betsChannel.close();
        } else {
          const bet = removebet?.payload;
          if (
            isBetEqualToOutcome(bet, payload.outcome) &&
            compareInString(bet.matchMarketId, payload?.matchMarketId)
          ) {
            betsChannel.close();
          }
        }
      }
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
  }
}

function* addSocketToBets(action) {
  try {
    yield fork(readBets, action.payload);
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
  }
}

function* placeBetWorker(action) {
  try {
    const { data, error } = yield call(
      BetslipService.placeBet,
      action?.payload
    );
    if (data) {
      if (data?.placed) {
        yield put(
          showSuccessMessage({
            tKey: "LOBBY.BET_PLACED"
          })
        );
        if (!action?.payload?.sponsoredBet) {
          yield put(ClearAllBat());
        }
        yield put(
          placebetSuccess({
            data: data,
            isSponsored: action?.payload?.sponsoredBet
          })
        );
      } else {
        yield put(updateBetsWithLatestApiData(data));
        yield put(
          placebetFailure({
            isSponsored: action?.payload?.sponsoredBet,
            error: data?.message?.message
          })
        );
      }
    }
    if (error) {
      if (action?.payload?.sponsoredBet) {
        yield put(showErrorMessage({ msg: error }));
        yield put(
          placebetFailure({ isSponsored: action?.payload?.sponsoredBet })
        );
      } else {
        yield put(
          placebetFailure({ isSponsored: action?.payload?.sponsoredBet, error })
        );
      }
    }
  } catch (error) {
    if (action?.payload?.sponsoredBet) {
      yield put(showErrorMessage({ msg: error }));
      yield put(
        placebetFailure({ isSponsored: action?.payload?.sponsoredBet })
      );
    } else {
      yield put(
        placebetFailure({ isSponsored: action?.payload?.sponsoredBet, error })
      );
    }
  }
}

export default betSlipWatcher;
